
























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import HIVETextField from "@/components/common/HIVETextField.vue";
import HIVEStatusDropDownList from "@/components/common/HIVEStatusDropDownList.vue";
import PasswordValidationRule from "@/classes/rules/PasswordValidationRule";
import UserValidationRule from "@/classes/rules/UserValidationRule";
import User from "@/classes/User";
import HIVEButton from "@/components/common/HIVEButton.vue";
import Organization from "@/classes/Organization";
import HIVESearchBar from "@/components/common/HIVESearchBar.vue";
import HeaderField from "@/classes/HeaderField";
import HIVEAlert from "@/components/common/alerts/HIVEAlert.vue";
import { AlertType } from "@/classes/enums/AlertType";

@Component({
  components: {
    HIVEStatusDropDownList,
    HIVETextField,
    HIVEButton,
    HIVESearchBar,
    HIVEAlert,
  },
})
export default class CreateUpdateOrganizationAdminForm extends Vue {
  @Prop(Boolean) public complete: boolean;
  @Prop(Number) public step: number;
  @Prop(Object) public organizationAdmin: User;
  @Prop(Boolean) public isNewOrganization: boolean;
  @Prop(Object) public organization: Organization;

  private userValidationRule: UserValidationRule = new UserValidationRule();
  private passwordValidationRule: PasswordValidationRule = new PasswordValidationRule();
  private search: string = "";
  private headers: Array<HeaderField> = [
    new HeaderField("Name", "displayName"),
    new HeaderField("Email", "email"),
  ];
  private selected = [];
  private delayTimer: any;

  private get initialFormSubmission() {
    return !this.organizationAdmin.email || !this.organizationAdmin.password
      ? true
      : false;
  }
  private get getOrganization() {
    return this.organization;
  }

  private get isComplete() {
    return this.complete;
  }

  private get getStepNumber() {
    return this.step;
  }

  private get getOrgAdmin() {
    return this.organizationAdmin;
  }

  private get newOrganization() {
    return this.isNewOrganization;
  }

  private get getUserItems() {
    return this.$store.getters["users/getSearchedUserItems"];
  }

  private set getUserItems(val: Array<User>) {
    this.$store.commit("users/setSearchedUserItems", val);
  }

  private get getExistingUserItems() {
    return this.$store.getters["users/getExistingUserItems"];
  }
  private set getExistingUserItems(val: Array<User>) {
    this.$store.commit("users/setExistingUserItems", val);
  }

  private get getIsLoading() {
    return this.$store.getters["users/getIsLoading"];
  }

  public get alertType() {
    return this.$store.getters["users/getAlertTypes"];
  }
  public set alertType(val: string) {
    this.$store.commit("users/setAlertType", val);
  }

  public get alertText() {
    return this.$store.getters["users/getAlertText"];
  }
  public set alertText(val: string) {
    this.$store.commit("users/setAlertText", val);
  }

  private userSelected(selected: object) {
    selected.value
      ? this.$store.dispatch("users/assignRoleAsync", selected.item)
      : this.$store.dispatch("users/removeRoleAsync", selected.item);
  }

  private clearUsers() {
    this.search = "";
    this.getUserItems = [];
    this.getExistingUserItems = [];
  }

  private searchUsers() {
    if (this.search.length >= 2) {
      this.$store.dispatch("users/searchAsync", {
        orgId: this.getOrganization.id,
        query: this.search,
      });
    }
  }

  private beforeDestroy() {
    this.clearUsers();
  }
}
